import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    Object.assign(state, state.getDefaultState());
  },
  resetOtherState(state) {
    Object.assign(state, state.otherState());
  },
  setSales: set("sales"),
  pushSales(state, data) {
    state.sales.push(data);
  },
  spliceSales(state, { index, qtde, data }) {
    if (data) state.sales.splice(index, qtde, data);
    else state.sales.splice(index, qtde);
  },
  setLoading: set("loading"),
  setLoadingLeads: set("loadingLeads"),
  setLoadingLeadsBySeller: set("loadingLeadsBySeller"),

  setFilters: set("filters"),
  setSalesPaid: set("salesPaid"),
  setSalesTotal: set("salesTotal"),
  setSalesDesqualify: set("salesDesqualify"),
  setsalesDesqualifyDeb: set("salesDesqualifyDeb"),
  setSalesDay: set("salesDay"),
  setSubscriptions: set("subscriptions"),
  setSubClasses: set("subclasses"),
  pushSubscriptions(state, data) {
    state.subscriptions.push(data);
  },
  spliceSubscriptions(state, { index, qtde, data }) {
    if (data) state.subscriptions.splice(index, qtde, data);
    else state.subscriptions.splice(index, qtde);
  },
  setQualifications: set("qualifications"),
  setContracts: set("contracts"),
  setContractsNotSign: set("contractsNotSign"),
  setActive: set("active"),
  setCanceled: set("canceled"),
  setDisqualified: set("disqualified"),
  setLeads: set("leads"),
  spliceLeads(state, { index, qtde, data }) {
    if (data) state.leads.splice(index, qtde, data);
    else state.leads.splice(index, qtde);
  },
  setLeadsBySeller: set("leads"),
  setCoupon: set("coupon"),

  setPlans: set("plans"),

  setTabulations: set("tabulations"),
  pushPlan(state, data) {
    state.plans.push(data);
  },
  pushSubClass(state, data) {
    state.subclasses.push(data);
  },
  pushTabulations(state, data) {
    state.tabulations.push(data);
  },
  splicePlans(state, { index, data }) {
    state.plans.splice(index, 1, data);
  },
  setLead: set("lead"),
  setUser: set("user"),
  setConsumerUnitUploaded: set("consumer_unit_uploaded"),
  setFile: set("file"),

  setProposalValidation(state, val) {
    state.proposal_validation = val;
  },
  setEmail(state, val) {
    state.user.email = val ? val.toLowerCase() : "";
  },
  setUtilityCompany(state, val) {
    state.user.utility_company = val;
  },
  setPlan(state, val) {
    if (!val) return null;
    const plan = {
      id: val.id,
      name: val.name,
      contract_time: val.contract_time,
      discount: val.discount,
      person_type: val.person_type,
    };
    state.user.plan = plan;
    state.plan = plan;
  },
  setPersonType(state, val) {
    state.user.person_type = val;
  },
  setCPF(state, val) {
    state.user.cpf = val;
  },
  setName(state, val) {
    state.user.name = val;
  },
  setCpfLegalResponsible(state, val) {
    state.user.cpf_legal_responsible = val;
  },
  setCompanyName(state, val) {
    state.user.company_name = val;
  },
  setIdDocument(state, val) {
    state.user.ID_document = val;
  },
  setPhone(state, val) {
    state.user.phone = val;
  },
  setCupom(state, val) {
    state.user.coupon = val;
    state.coupon = val;
  },
  setRG(state, val) {
    state.user.rg = val;
  },
  setOrgaoExpeditor(state, val) {
    state.user.orgao_expeditor = val;
  },
  setBirthday(state, val) {
    state.user.date_of_birth = val;
  },
  setGender(state, val) {
    state.user.gender = val;
  },
  setCEP(state, val) {
    state.user.address.postal_code = val;
  },
  setUserAddress(state, val) {
    state.user.address = val;
  },
  resetUserAddress(state) {
    state.user.address = {
      address: "",
      address_number: "",
      address_complement: "",
      district: "",
      postal_code: "",
      state: {
        name: "Minas Gerais",
        initials: "MG",
      },
      city: "",
      country: {
        name: "Brasil",
        initials: "BR",
      },
    };
  },
  setLogradouro(state, val) {
    state.user.address.address = val;
  },
  setNumero(state, val) {
    state.user.address.address_number = val;
  },
  setComplemento(state, val) {
    state.user.address.address_complement = val;
  },
  setBairro(state, val) {
    state.user.address.district = val;
  },
  setLocalidade(state, val) {
    state.user.address.city = val;
  },
  setState(state, val) {
    state.user.address.state = val;
  },
  setPaymentType(state, val) {
    state.user.payment_type = val;
  },
  setContract(state, val) {
    state.user.enercred_contract = val;
  },
  setIndicator(state, val) {
    state.user.promo_code = val ? val.toLowerCase() : "";
  },
  setSalesObservation(state, val) {
    state.user.sales_observation = val;
  },
  setSignedContractBy(state, val) {
    state.user.signedcontract_by = val;
  },
  setAverageConsumption(state, val) {
    state.user.average_consumption = val;
  },

  setQualificationsForm: set("qualifications_form"),
  pushSalesDay(state, data) {
    state.salesDay.push(data);
  },
  spliceSalesDay(state, { index, data }) {
    state.salesDay.splice(index, 1, data);
  },
  setIsCorreios(state, val) {
    state.isCorreios = val;
  },
  setSellers(state, val) {
    state.sellers = val;
  },
  setSeller(state, val) {
    state.seller = val;
  },
  setReSubscription(state, val) {
    state.reSubscription = val;
  },
};
